"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../../styles");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));
var _components = require("../../components");
var _ = require("./..");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Fixed = function Fixed(_ref) {
  var children = _ref.children,
    pages = _ref.pages;
  var theme = (0, _styles.useTheme)();
  var isMd = (0, _useMediaQuery.default)(theme.breakpoints.up('md'), {
    defaultMatches: true
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openSidebar = _useState2[0],
    setOpenSidebar = _useState2[1];
  var handleSidebarOpen = function handleSidebarOpen() {
    setOpenSidebar(true);
  };
  var handleSidebarClose = function handleSidebarClose() {
    setOpenSidebar(false);
  };
  var open = isMd ? false : openSidebar;
  return /*#__PURE__*/_react.default.createElement(_Box.default, null, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: 'fixed',
    sx: {
      backgroundColor: theme.palette.background.paper,
      borderBottom: "1px solid ".concat((0, _styles.alpha)(theme.palette.divider, 0.1))
    },
    elevation: 0
  }, /*#__PURE__*/_react.default.createElement(_.Container, {
    maxWidth: 1,
    paddingY: {
      xs: 1,
      sm: 1.5
    }
  }, /*#__PURE__*/_react.default.createElement(_components.Topbar, {
    onSidebarOpen: handleSidebarOpen
  }))), /*#__PURE__*/_react.default.createElement(_components.Sidebar, {
    onClose: handleSidebarClose,
    open: open,
    variant: isMd ? 'permanent' : 'temporary',
    pages: pages
  }), /*#__PURE__*/_react.default.createElement("main", null, /*#__PURE__*/_react.default.createElement(_Box.default, {
    height: {
      xs: 58,
      sm: 66,
      md: 71
    }
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    paddingLeft: {
      md: '256px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto"
  }, children, /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_.Container, {
    paddingY: 4
  }, /*#__PURE__*/_react.default.createElement(_components.Footer, null)))))));
};
Fixed.propTypes = {
  children: _propTypes.default.node
};
var _default = Fixed;
exports.default = _default;